import axios from "axios";
import query from "./constants.api";

// const config : AxiosRequestConfig = {baseURL: 'https://jsonplaceholder.typicode.com'}
// export const axiosInstance = axios.create(config);

const axiosInstance = (method, url, data, type, baseUrl) => {
    const contentType = type ? type : 'application/x-www-form-urlencoded';

    // const accessToken = 'Bearer ' + localStorage.getItem('mico_token');
    const headers = {
        'content-type': contentType,
        Authorization: localStorage.getItem('mico_token'),
    };

    let config = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : query.baseURL,
        url: url ? url : '',
        headers: headers,
        data: method === 'POST' || method === 'PUT' ? data : null,
        params: method === 'POST' || method === 'PUT' ? null : data,
    };

    return axios(config);
};

export default axiosInstance;
